import { Component, OnInit, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { FormlyModule } from '@ngx-formly/core';
import { of } from 'rxjs';

import { FormlyFieldBaseComponent } from '../formly-field-base.component';
import { ModalService } from '../../../services';
import { Search } from '../../../models';
import { ignoreModalError } from '../../../helpers';
import { SearchModalComponent } from '../../modals/search-modal/search-modal.component';

@Component({
  selector: 'app-formly-input-search',
  templateUrl: './formly-input-search.component.html',
  styleUrl: './formly-input-search.component.scss',
  imports: [FormsModule, FormlyModule, ReactiveFormsModule, NgbPopover],
})
export class FormlyInputSearchComponent extends FormlyFieldBaseComponent implements OnInit {
  private readonly modalService = inject(ModalService);

  ngOnInit(): void {
    this.reset();
  }

  clearSearch(searchBox: HTMLInputElement) {
    this.form.patchValue({ [this.key]: '' } as any);
    searchBox.focus();
    if (this.props.clear) {
      this.props.clear();
    }
  }

  search() {
    const search = this.field.model[this.key];
    if (this.props.search) {
      this.props.search(search);
    } else if (this.props.service) {
      this.props.service
        .search({
          search,
          id: this.props.id ?? this.field.model.id,
          id2: this.props.id2 ?? this.field.model.id2,
          bool1: this.props.bool1,
          bool2: this.props.bool2,
          includeAll: this.field.model.includeAll,
          allowIncludeAllBlankSearch: this.props.allowIncludeAllBlankSearch,
          allowBlankSearch: this.props.allowBlankSearch,
        })
        .pipe(this.untilDestroyed())
        .subscribe((results: any[]) => this.subscribeResults(results, search, true));
    } else if (this.props.serviceTextileMan) {
      this.props.serviceTextileMan
        .search(search)
        .pipe(this.untilDestroyed())
        .subscribe((results: any[]) => this.subscribeResults(results, search, false));
    }
  }

  private subscribeResults(results: any[], search: string, showSave: boolean) {
    if (this.props.results) {
      this.props.results(of(results));
    }

    if (search && results.length === 1) {
      this.onSelected(results[0]);
    } else if (this.props.openModal) {
      const { modal, component } = this.modalService.openXL<SearchModalComponent>(SearchModalComponent);
      component.header.set(this.props.label);
      component.columnDefs.set(this.props.columnDefs);
      component.service.set(this.props.service);
      component.model.set({ search, includeAll: false, bool1: this.props.bool1, bool2: this.props.bool2 } as Search);
      component.id.set(this.props.id);
      component.id2.set(this.props.id2);
      component.bool1.set(this.props.bool1);
      component.bool2.set(this.props.bool2);
      component.allLabel.set(this.props.allLabel);
      component.createComponent.set(this.props.createComponent);
      component.results$.set(of(results));
      component.showSave.set(showSave);
      modal.result.then((result) => this.onSelected(result), ignoreModalError);
    }
  }

  private onSelected(result: any) {
    if (this.props.selected) {
      this.props.selected(result);
    }
  }

  private reset() {
    if (this.key && !this.model[this.key]) {
      this.form.patchValue({ [this.key]: '' } as any);
    }
  }

  edit(event: any) {
    if (this.props.onClick) {
      this.props.onClick(event);
    }
  }
}
